<template>
  <div id="app">
    <main>
      <router-view name="header"></router-view>
      <div
        class="kt-grid kt-wizard-v1 bg-transparent-primary kt-wizard-v1--white"
        id="kt_wizard_v1"
        data-ktwizard-state="first"
      >
        <router-view name="wizard"></router-view>
      </div>
      <router-view name="banner"></router-view>
      <fade-transition origin="center" mode="out-in" :duration="350">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
import { FadeTransition } from "vue2-transitions";

export default {
  name: "personaliza",
  components: {
    FadeTransition,
  },
};
</script>

<style scoped></style>
